/**
 * WebSocket client for multiplayer rooms.
 *
 * Provides a singleton socket.io connection and typed event helpers.
 * Only connects when entering multiplayer — solo mode never opens a socket.
 */

import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io("/", {
      autoConnect: false,
      transports: ["websocket", "polling"],
    });
  }
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) s.connect();
  return s;
}

export function disconnectSocket() {
  if (socket?.connected) socket.disconnect();
}
